import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellCountry } from '../../table/cells/CellCountry';

export const ModelCellCountryBase = (props: TableInheritedProps) => (
  <CellCountry {...props} />
);

export const ModelCellCountry = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellCountry',
    ModelCellCountryBase,
    props
  );
